import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingTable from "./BookingTable";

const Booking = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking" />

      {/* TableDataLayer */}
      {/* <AllCounselorTableLayer url={"counselors"} /> */}
      <BookingTable />
    </MasterLayout>
  );
};

export default Booking;
